// extracted by mini-css-extract-plugin
export default {"producemarket":"f20abe83c7868d2d2085","name":"d91fb5a4950859d20b54"};